module.exports = __webpack_public_path__ + "static/available_everywhere-1e4068efc4a99767efd9a8260503ede6.svg";